export default "Coup de pouce CVC tertiaire — Bonification CEE BAT-TH | Solution Éco France";
